import { Paper, styled } from '@mui/material';

export const Card = styled(Paper)`
  padding: 20px 24px;
  border-radius: 8px;
`;
